import { render, staticRenderFns } from "./ResourceControlList.vue?vue&type=template&id=9d82fe16&scoped=true"
import script from "./ResourceControlList.vue?vue&type=script&lang=js"
export * from "./ResourceControlList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d82fe16",
  null
  
)

export default component.exports